export default "__VITE_ASSET__0Mxyal55__"